import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.GuidedIntakePromoCard'

export default defineMessages({
  betaBadge: {
    id: `${scope}.betaBadge`,
    defaultMessage: 'Beta',
  },
})
